module.exports = __webpack_public_path__ + "img/user-task.24460b5b.svg";